import React from 'react';
import { KeyDownEvent } from '../../../utils/eventKey';
import i18next from 'i18next';

const ModalFooter = ({addItem, buttonLabel, closePopup, itemsLength}) => (
    <div className="modal-content-footer common-popup-footer ai-rw-modal-footer">
        {
          closePopup && 
          <div role="button" tabIndex="0" className="wb-btn-med ghost-wb-btn-med" 
            onClick={closePopup}
            onKeyDown={(e) => {KeyDownEvent(e, () => closePopup())}}
          >
            {i18next.t("Cancel")}
          </div>
        }
        <div role="button" data-testid="kr-add-button" tabIndex="0" className="wb-btn-med primary-wb-btn-med"
          onClick={e => addItem(e)}
          onKeyDown={(e) => {KeyDownEvent(e, () => addItem(e))}}
        >
          {buttonLabel}
        </div>
    </div>
  );

export default ModalFooter;